import React, { useEffect, useState } from 'react';

const Image = (props) => {
  const { name, ...rest } = props;
  const [image, setImage] = useState(null);

  useEffect(() => {
    import(/* webpackMode: "eager" */ `app/images/${name}`).then(setImage);

    return () => {
      setImage(null);
    };
  }, [name]);

  if (!image) {
    return <img alt='not found' />;
  }

  return <img src={image.default} alt={image.name} {...rest} />;
};

export default Image;
